import { Component, OnInit } from '@angular/core';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';

import { FinanceService } from '../../../services';
import { InvoiceDetailModal } from '../../../modals';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-dashboard-invoice-list',
  templateUrl: './dashboard-invoice-list.component.html',
  styleUrls: ['./dashboard-invoice-list.component.scss'],
})
export class DashboardInvoiceListComponent implements OnInit {
  filter: AppFilter = new AppFilter();
  baseUrl = environment.API_SERVER;
  pending: boolean;
  success: any;
  error: any;
  invoices: Array<any> = [];
  totalItems: number = 5;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  departments: Array<any> = [];
  searchFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'invoiceNumber',
        op: 'ne',
        data: null,
      },
    ],
  };
  customerNCCID: string;
  organizationId: string;
  constructor(
    private router: Router,
    private modalService: SuiModalService,
    private financeSvc: FinanceService
  ) {
    this.organizationId = window.localStorage.getItem('organizationId');
    // this.customerNCCID = '000-0112';
    this.customerNCCID = JSON.parse(
      window.localStorage.getItem('organization')
    )['jpaContractor']['nccId'];
    this.filter = new AppFilter({ sidx: 'dateCreated', sord: 'desc' });
    this.filter.filters = JSON.stringify(this.searchFilter);
    // this.filter._search = false;
    this.getPage(1);
    // this.payment(1);s
  }
  goBack() {}

  download(invoice) {
    this.getInvoiceDetail(invoice['invoiceNumber']);
  }

  getInvoiceDetail(invoiceNumber) {
    this.pending = true;
    this.error = null;
    this.financeSvc
      .getInvoiceDetail({ params: { invoiceNumber: invoiceNumber } })
      .subscribe(
        (res: any) => {
          let url = `${environment.API_SERVER}/finance/public/media/?media=${res['invoiceDocumentPath']}`;
          window.open(url, '_blank');
          this.pending = false;
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
        }
      );
  }
  // get page request organization with filter params
  getPage(page: number) {
    // set the page number from the caller
    this.filter.page = page;
    this.pending = true;
    this.error = null;
    this.financeSvc
      .getInvoices({
        params: { ...this.filter, ...{ customerNccId: this.customerNCCID } },
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.totalItems = +res.records;
          this.rows = this.filter.rows;
          this.currentPage = this.filter.page;
          this.invoices = res['rows'];
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
        }
      );
  }
  viewDepartment(invoice) {
    this.modalService
      .open(new InvoiceDetailModal('Invoice Detail', invoice, ModalSize.Tiny))
      .onApprove((value: any) => {
        console.log(value, 'value');
        // Check for if a simalar equipment in tamsy has been paid for
        if (value.invoiceDetails.categoryName === 'Type Approval') {
          this.checkSimilarEquipment(value, invoice);
        } else {
          if (value.paymentDetail) {
            window.location.href = value['paymentDetail']['paymentUrl'];
          } else {
            this.router.navigate(
              [
                '/contractor/payment/pay',
                value.invoiceDetails.revenueServiceId,
              ],
              {
                queryParams: {
                  purpose: invoice['categoryName'],
                  amount: invoice['amount'],
                  allowPartPayment: invoice['serviceAllowPartPayment'],
                  revenueServiceId: value['invoiceDetails']['revenueServiceId'],
                  requireInvoiceNo: invoice['serviceReqInvoiceNo'],
                  currencyCode: invoice['currencyCode'],
                  invoiceNumber: value['invoiceDetails']['invoiceNumber'],
                },
              }
            );
          }
        }
      })
      .onDeny(() => {});
  }

  checkSimilarEquipment(value, invoice) {
    this.pending = true;
    this.financeSvc
      .checkSimilarEquipment({
        invoiceNumber: value.invoiceDetails.invoiceNumber,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          if (res.status == true) {
            this.error = `This Invoice has a similar equipment that has already been Paid for `;
          } else {
            if (value.paymentDetail) {
              window.location.href = value['paymentDetail']['paymentUrl'];
            } else {
              this.router.navigate(
                [
                  '/contractor/payment/pay',
                  value.invoiceDetails.revenueServiceId,
                ],
                {
                  queryParams: {
                    purpose: invoice['categoryName'],
                    amount: invoice['amount'],
                    allowPartPayment: invoice['serviceAllowPartPayment'],
                    revenueServiceId:
                      value['invoiceDetails']['revenueServiceId'],
                    requireInvoiceNo: invoice['serviceReqInvoiceNo'],
                    currencyCode: invoice['currencyCode'],
                    invoiceNumber: value['invoiceDetails']['invoiceNumber'],
                  },
                }
              );
            }
          }
        },
        (error) => {
          this.pending = true;
          this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
        }
      );
  }

  searchRecords(search) {
    let searchFilter = {
      groupOp: 'OR',
      rules: [
        {
          field: 'invoiceNumber',
          op: 'cn',
          data: '',
        },
        {
          field: 'categoryName',
          op: 'cn',
          data: '',
        },
        // {
        //   field: 'organizationTypeId.organizationTypeId',
        //   op: 'eq',
        //   data: 'contractor',
        // },
        // {
        //   field: 'organizationShortName',
        //   op: 'cn',
        //   data: '',
        // },
      ],
    };
    searchFilter.rules.forEach((rule) => {
      rule.data = search;
    });
    this.filter.filters = JSON.stringify(searchFilter);
    this.getPage(1);
  }
  //handle sorting records
  sortRecords(search) {
    this.filter.sord = search;
    this.getPage(1);
  }

  //handles rows display
  displayRecords(row) {
    this.filter['rows'] = row;
    this.getPage(1);
  }
  onDisplayRecords(value) {
    this.filter.rows = value;
    this.getPage(this.filter.page);
  }

  nextPage(value) {
    this.filter.page = value;
    this.getPage(this.filter.page);
  }
  ngOnInit(): void {}
}
